module.exports = __webpack_public_path__ + "img/rule-bg-en.f6edea58.png";